import { render } from "./MoviesCarousel.vue?vue&type=template&id=d8438c54&ts=true"
import script from "./MoviesCarousel.vue?vue&type=script&lang=ts"
export * from "./MoviesCarousel.vue?vue&type=script&lang=ts"

import "./MoviesCarousel.vue?vue&type=style&index=0&id=d8438c54&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__